import styled from "styled-components";

const EmailUsCss = styled.div`
  font-family: "Poppins";
  text-align: center;
  align-items: center;

  .wrapper {
    background: linear-gradient(
      180deg,
      #0a171a 0%,
      #163940 100.97%,
      #255862 190.07%
    );
    .signup {
      display: flex;
      @media (max-width: 650px) {
        display: none;
      }
      flex-direction: column;
      justify-content: space-between;
      .top {
        display: flex;
        justify-content: space-between;
        .text {
          padding: 2rem 5rem;
          margin-left: auto;
          margin-right: auto;
          flex: 0.5;
          color: white;
          font-family: Poppins;
          font-size: 35px;
          font-style: normal;
          font-weight: 300;
          line-height: 60px;
          letter-spacing: 0em;
          text-align: center;
          @media (max-width: 1700px) {
            font-size: 30px;
            line-height: 42px;
          }
          @media (max-width: 1100px) {
            font-size: 22px;
            line-height: 24px;
            padding: 2rem 3rem;
          }
        }
      }
      .middle {
        display: flex;
        justify-content: space-between;
        .left {
          flex: 0.5;
          padding: 2rem 5rem;
          margin: auto;
          @media (max-width: 1700px) {
            padding: 1rem 5rem;
            margin-top: 1rem;
          }
          @media (max-width: 1100px) {
            display: flex;
            padding: 1rem 5rem;
            margin-top: 1rem;
          }
          img {
            padding: 0 1rem 0 1rem;
            @media (max-width: 1700px) {
              width: 30%;
            }
            @media (max-width: 1100px) {
              width: 40%;
              padding: 0 0.5rem 0 0.5rem;
            }
          }
        }
        .right {
          flex: 0.5;
          padding: 2rem 5rem;
          @media (max-width: 1700px) {
            padding: 0rem 5rem;
            margin-top: 0;
          }
          img {
            margin: auto;
            @media (max-width: 1700px) {
              width: 30%;
            }
          }
        }
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        .left {
          flex: 0.5;
          padding: 2rem 4rem;
          .discussBtn {
            margin-top: 1rem;
            margin-bottom: 1rem;
            width: 45%;
            font-family: Poppins;
            height: 4rem;
            background-color: #fdcd0b;
            border-radius: 13px;
            font-style: normal;
            font-weight: 500;
            font-size: 26px;
            line-height: 39px;
            color: #1c454c;
            transition: transform 0.2s;
            &:hover {
              transform: scale(1.1);
            }
            @media (max-width: 1700px) {
              font-size: 16px;
              font-weight: 550;
              width: 55%;
              height: 3.5rem;
              border-radius: 12px;
            }
            @media (max-width: 1100px) {
              font-size: 14px;
              font-weight: 525;
              // width: 55%;
              width: 30vw;
              height: 2.5rem;
              border-radius: 10px;
            }
          }
        }
        .right {
          flex: 0.5;
          padding: 2rem 4rem;
          form {
            position: relative;
            margin-top: 1rem;
            margin-bottom: 1rem;
            input {
              height: 4rem;
              padding-left: 1rem;
              border-radius: 10px;
              // margin: auto !important;
              background-color: #0d1f23;
              border: 0;
              width: 55%;
              color: white;
              font-family: Poppins;
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 30px;
              letter-spacing: 0em;
              text-align: left;
              &:focus {
                outline: 0;
              }
              @media (max-width: 1700px) {
                font-size: 16px;
                font-weight: 500;
                width: 65%;
                height: 3.5rem;
                border-radius: 12px;
              }
              @media (max-width: 1100px) {
                font-size: 12px;
                font-weight: 525;
                // width: 55%;
                width: 30vw;
                height: 2.5rem;
                border-radius: 10px;
              }
            }
            button {
              position: relative;
              border: none;
              margin-left: -3.5rem;
              background: transparent;
              &:hover {
                transform: scale(1.1);
              }
              @media (max-width: 1100px) {
                // margin-right: -2.5rem;
                width: 40px;
              }

              .circle {
                position: absolute;
                color: #fdcd0b !important;
                bottom: -0.3rem;
              }
            }
          }
        }
      }
    }
    .mobile {
      display: none;
      @media (max-width: 650px) {
        display: flex;
      }
      justify-content: space-between;
      flex-direction: column;
      text-align: center;

      .up {
        .top {
          .text {
            padding: 2rem 5rem;
            margin-left: auto;
            margin-right: auto;
            flex: 0.5;
            color: white;
            font-family: Poppins;
            font-size: 40px;
            font-style: normal;
            font-weight: 300;
            line-height: 60px;
            letter-spacing: 0em;
            text-align: center;
            @media (max-width: 1700px) {
              font-size: 30px;
              line-height: 42px;
            }
            @media (max-width: 1100px) {
              font-size: 22px;
              line-height: 24px;
              padding: 2rem 3rem;
            }
          }
        }
        .middle {
          .images {
            display: flex;
            justify-content: space-around;
            width: 27%;
            margin-left: auto;
            margin-right: auto;
            .image {
              padding: 0 1rem;
            }
          }
        }
        .bottom {
          .circle {
            position: absolute;
            color: #fdcd0b !important;
            bottom: -0.3rem;
          }
          .btnDiv {
            padding: 2rem 0;

            .discussBtn {
              width: 50%;
              font-family: Poppins;
              height: 2.5rem;
              background-color: #fdcd0b;
              border-radius: 8px;
              font-style: normal;
              font-weight: 500;
              font-size: 18px;
              line-height: 21px;
              color: #1c454c;
              transition: transform 0.2s;
              &:hover {
                transform: scale(1.1);
              }
              @media (max-width: 420px) {
                font-size: 14px;
                line-height: 20px;
              }
              @media (max-width: 340px) {
                font-size: 12px;
                line-height: 20px;
              }
            }
          }
        }
      }
      .down {
        .top {
          .text {
            padding: 2rem 5rem;
            margin-left: auto;
            margin-right: auto;
            flex: 0.5;
            color: white;
            font-family: Poppins;
            font-size: 40px;
            font-style: normal;
            font-weight: 300;
            line-height: 60px;
            letter-spacing: 0em;
            text-align: center;
            @media (max-width: 1700px) {
              font-size: 30px;
              line-height: 42px;
            }
            @media (max-width: 1100px) {
              font-size: 22px;
              line-height: 24px;
              padding: 2rem 3rem;
            }
          }
        }
        .middle {
          .images {
            display: flex;
            justify-content: space-around;
            width: 32%;
            margin-left: auto;
            margin-right: auto;
            .image {
              padding: 0 1rem;
            }
          }
        }
        .bottom {
          .emaildiv {
            form {
              position: relative;
              padding-top: 2rem;
              padding-bottom: 2rem;
              input {
                height: 2.5rem;
                padding-left: 1rem;
                border-radius: 8px;
                // margin: auto !important;
                background-color: #0d1f23;
                border: 0;
                width: 70%;
                color: white;
                font-family: Poppins;
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: 30px;
                letter-spacing: 0em;
                text-align: left;
                &:focus {
                  outline: 0;
                }
                @media (max-width: 420px) {
                  font-size: 14px;
                  line-height: 20px;
                }
                @media (max-width: 340px) {
                  font-size: 12px;
                  line-height: 20px;
                }
              }
              button {
                position: relative;
                border: none;
                margin-left: -3.5rem;
                background: transparent;
                &:hover {
                  transform: scale(1.1);
                }
                @media (max-width: 1100px) {
                  // margin-right: -2.5rem;
                  width: 40px;
                }
                .circle {
                  position: absolute;
                  color: #fdcd0b !important;
                  bottom: -0.25rem;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default EmailUsCss;
